import { LINCOLN_BRAND } from "../components/accessories/Brands";
import { IS_CANADA_MARKET, IS_USA_MARKET } from "./EmpUtil";
import { isCanadianPreorderUser } from "./canadianPreorderExperience";

export const DELIVERY_TOOLS_ROLES = [
  "EMP_ECOMM_CUSTOMERHANDLING",
  "EMP_MODELE",
];

export const LINCOLN_DELIVERY_PILOT_ROLES = DELIVERY_TOOLS_ROLES;

const getRoles = (user) => {
  if (Array.isArray(user?.roles)) {
    return user.roles;
  }

  if (user?.roles && typeof user.roles === "object") {
    return Object.values(user.roles);
  }

  return [];
};

const hasDeliveryToolsRole = (user) => {
  const roles = getRoles(user);

  return DELIVERY_TOOLS_ROLES.some((role) => roles.includes(role));
};

export const isCanadianDeliveryToolsUser = (user) =>
  IS_CANADA_MARKET(user?.market) &&
  (hasDeliveryToolsRole(user) || isCanadianPreorderUser(user));

export const isCanadianRestrictedDeliveryToolsUser = (user) =>
  isCanadianDeliveryToolsUser(user) && !isCanadianPreorderUser(user);

export const isLincolnDeliveryPilotUser = (user) =>
  IS_USA_MARKET(user?.market) &&
  user?.brand === LINCOLN_BRAND &&
  hasDeliveryToolsRole(user);

export const isRestrictedDeliveryToolsUser = (user) =>
  isLincolnDeliveryPilotUser(user) ||
  isCanadianRestrictedDeliveryToolsUser(user);

export const canAccessDeliveryTools = (user) =>
  IS_USA_MARKET(user?.market) || isCanadianDeliveryToolsUser(user);
